function SectionLabel({ children, style }) {
  return (
    <div className="ul-section-label" style={style}>
      {children}
    </div>
  );
}

export default SectionLabel;
